<template>
  <div class="modal fade form-modal"
       id="bannerFormModal"
       data-bs-backdrop="static"
       data-bs-keyboard="false"
       tabindex="-1"
       aria-labelledby="bannerFormModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button type="button"
                class="btn-close position-absolute"
                data-bs-dismiss="modal"
                aria-label="Close">
        </button>
        <div class="modal-body py-0">
          <Form :isModal="true"
                :form="form"
                :successFormMessage="successFormMessage"
                @openModal="handleSuccessModal"
                :modalClosed="modalClosed"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/components/banners/Form";

export default {
  components: {Form},
  props: {
    form: {
      firstName: {
        label: String,
        placeholder: String
      },
      lastName: {
        label: String,
        placeholder: String
      },
      email: {
        label: String,
        placeholder: String
      },
      phoneNumber: {
        label: String,
        placeholder: String
      },
      company: {
        label: String,
        placeholder: String
      },
      city: {
        label: String,
        placeholder: String
      },
      state: {
        label: String,
        placeholder: String
      },
      inquiry: {
        label: String,
        placeholder: String,
        options: [String]
      },
      checkbox: String,
      button: {
        text: String
      },
      countries: [
        {
          name: String,
          states: [String]
        }
      ]
    },
    successFormMessage: Object
  },
  data() {
    return {
      successModal: false,
      modalClosed: true
    }
  },
  methods: {
    handleSuccessModal(close) {
      this.$data.successModal = !this.$data.successModal
      close && (this.$data.modalClosed = true)
    }
  }
}
</script>
